import { DiningInfoProps, DinnerShiftPreferencesContentFragment } from '@msc-b2c/interfaces/types';
import styles from '../stateroomdetails.module.scss';
import { Text } from '@msc-b2c/shared-components';
import { fetchContentFragmentsFromCms } from '@msc-b2c/shared-utils';
import { IDinnerShiftPreferencesContentFragment } from '@msc-b2c/interfaces/interfaces';
import { useEffect, useState } from 'react';

const DiningInfo: React.FC<DiningInfoProps> = ({ diningSectionTitle, diningOptionsData }) => {
  const [dinnerShiftCF, setDinnerShiftCF] = useState<DinnerShiftPreferencesContentFragment[]>([]);
  const [diningOptionLabel, setDiningOptionLabel] = useState<string>('');

  const fetchDinnerShiftContentFragments = () => {
    fetchContentFragmentsFromCms<IDinnerShiftPreferencesContentFragment, undefined>(
      'getDinnerShifts'
    )
      .then((result) => setDinnerShiftCF(result.data.dinnerShiftCfmList.items))
      .catch((error) => {
        console.error('Error fetching dinner shift content fragments:', error);
      });
  };

  useEffect(() => {
    fetchDinnerShiftContentFragments();
  }, []);

  useEffect(() => {
    if (dinnerShiftCF.length > 0 && diningOptionsData?.code) {
      const match = dinnerShiftCF.find(
        (fragment) => fragment.dinnerShiftId === diningOptionsData.code
      );

      if (match?.myAreaDinnershiftDescription?.html) {
        setDiningOptionLabel(match.myAreaDinnershiftDescription.html);
      } else if (match?.dinnerShiftLabel) {
        setDiningOptionLabel(match.dinnerShiftLabel);
      }
    }
  }, [dinnerShiftCF, diningOptionsData]);

  return (
    <div className={styles.diningInfoContainer}>
      <Text
        text={diningSectionTitle}
        styleOption={styles.diningInfoTitle}
      />
      <div className={styles.diningInfoContent}>
        {diningOptionLabel && (
          <Text
            text={diningOptionLabel}
            styleOption={styles.diningInfoValue}
          />
        )}
      </div>
    </div>
  );
};

export default DiningInfo;
